import { useEffect, useState } from "preact/hooks";
import type { FlowState, FlowStore } from "../flow/machine";
import { locale, onLocaleChange, type Locale } from "../i18n";

export function useFlowState(store: FlowStore): FlowState {
  const [s, set] = useState(store.state);
  useEffect(() => store.subscribe(set), [store]);
  return s;
}

export function useLocale(): Locale {
  const [l, set] = useState(locale());
  useEffect(() => onLocaleChange(set), []);
  return l;
}

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

/** Moves focus to the step heading when the step changes (screen readers announce it). */
export function useFocusOnStep(step: string): void {
  useEffect(() => {
    const h = document.querySelector<HTMLElement>("main h2[tabindex='-1']");
    h?.focus();
  }, [step]);
}
